#import "../fragments/edition-fragment.graphql"

query GetEdition($editionId: ID!) {
    edition(id: $editionId) {
        ...EditionFragment
    }
}
